/* import __COLOCATED_TEMPLATE__ from './react-native-platform.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import templateOnlyComponent from '@ember/component/template-only';
import type {
  INSTALLATION_METHOD,
  PROGRAMMING_LANGUAGES,
} from 'embercom/components/installation-new/constants';

interface Signature {
  Element: HTMLElement;
  Args: {
    selectedBackendInstallationMethod: INSTALLATION_METHOD | PROGRAMMING_LANGUAGES;
    backendInstallationMethods: any[];
    setSelectedBackendInstallationMethod: (method: string) => void;
    onPingDomainsCountChange: (count: number) => void;
    onPingDomainsUnresolvedErrorCountChange: (count: number) => void;
  };
}

const ReactNativePlatform = templateOnlyComponent<Signature>();
export default ReactNativePlatform;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'MessengerSettings::Security::ReactNativePlatform': typeof ReactNativePlatform;
  }
}
